import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IClusterState } from './cluster';

const clusterStateSelector = createFeatureSelector<IClusterState>('cluster');

export const selectResponseCluster = createSelector(
  clusterStateSelector,
  (state: IClusterState) => state.operationCluster
);
